// import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
// import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
// import Checkbox from "components/Checkbox/Checkbox";
import moment from 'moment';
import Button from "components/Button/Button"
// import { getStatusButtonColor } from "helpers/utils";

export default {
    TABLE: {
        className: "data-table-tasks",
        initialSortKey: "assigned",
        initialSortOrder: "desc"
    },

    COLUMN: [
        // {
        //     label: "Row Selector",
        //     key: "row-selector",
        //     header: ({ customTableProps }) => {
        //         const isSelectedAll =
        //             customTableProps.selectedRows &&
        //             customTableProps.selectedRows.length &&
        //             customTableProps.rowsData &&
        //             customTableProps.rowsData.length &&
        //             customTableProps.selectedRows.length ===
        //                 customTableProps.rowsData.length
        //                 ? true
        //                 : false;
        //         return (
        //             <Checkbox
        //                 checked={isSelectedAll}
        //                 onChange={() => customTableProps.doSelectAll()}
        //                 name="row-selector"
        //             />
        //         );
        //     },
        //     className: "col-row-selector",
        //     format: ({ rowData, customTableProps }) => {
        //         const isSelected =
        //             customTableProps.selectedRows &&
        //             customTableProps.selectedRows.length &&
        //             customTableProps.selectedRows.includes(rowData)
        //                 ? true
        //                 : false;
        //         return (
        //             <Checkbox
        //                 checked={isSelected}
        //                 onChange={() => customTableProps.onRowSelect({ rowData })}
        //                 name="row-selector"
        //             />
        //         );
        //     },
        //     canBeHidden: true
        // },
        {
            label: "Task name",
            header: "TASK NAME",
            key: "task",
            sortable: true,
            className: "title",
            format: ({ rowData }) => {
                return <span>{rowData["task"]}</span>;
            }
        },
        {
            label: "Regulatory",
            header: "REGULATORY",
            key: "regulatory_act",
            sortable: true,
            className: "",
            format: ({ rowData }) => {
                return <span>{rowData["regulatory_act"]}</span>;
            }
        },
        {
            label: "Type",
            header: "TYPE",
            key: "type",
            sortable: true,
            className: "",
            format: ({ rowData }) => {
                return <span>{rowData["typeLabel"]}</span>;
            }
        },
        {
            label: "Date requested",
            header: "DATE REQUESTED",
            key: "assigned",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData['assigned'] ? moment(rowData['assigned']).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "Completed",
            header: "DATE COMPLETED",
            key: "completed_on",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData['completed_on'] ? moment(rowData['completed_on']).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "Status",
            header: "STATUS",
            key: "status",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>
                    <Button
                        disabled={rowData.locked === "t" ? true : false}
                        cursorDefault={customTableProps.cursorDefault}
                        color={rowData.statusType}
                        size="md"
                        icon={rowData.locked === "t" ? "fas fa-lock" : false}
                        text={rowData.statusLabel}
                        onClick={() => null}
                    />
                </span>;
            }
        },
        {
            label: "Site",
            header: "SITE",
            key: "site",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span style={{ minWidth: 120 }}>{rowData.siteName == null ? 'All Sites' : rowData.siteName}</span>;
            }
        },
        {
            label: "Action",
            header: "ACTION",
            key: "action",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span><Button size="md" disabled={rowData.locked === "t" ? true : false} text={rowData.buttonLabel} onClick={() => null} /></span>;
            }
        },
    ]
};
